"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'shortcuts.knowledge.title': 'Apri Selettore Conoscenza',
    'shortcuts.knowledge.description': 'Apre il selettore di conoscenza per cercare e selezionare fonti di conoscenza',
};
